import { Component, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';

import { Subject } from 'rxjs';

import { SubscriptionFacadeService } from '../../services/subscription-facade.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@Component({
    selector: 'financial-knowledge7-form',
    templateUrl: './financial-knowledge7-form.component.html',
    styleUrls: ['./financial-knowledge7-form.component.scss'],
    standalone: false
})
export class FinancialKnowledge7FormComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  viewerOpen1 = false;
  viewerOpen2 = false;
  subscriptions: any[] = [];

  doneSubject: Subject<void> = new Subject<void>();
  page: number = 1;

  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);
  }

  onSubmit() {
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
